import { Title } from '@sr-sdks/api-sdk-axios';
import { TITLES_QUERY_DOMAIN_KEY } from '../../api/titles/titlesApi';
import { useCachedPaginatedItem } from '../../hooks/useCachedPaginatedItem';

interface ILookupTitleProps {
  id?: null | string;
}

const LookupTitleName = ({ id }: ILookupTitleProps) => {
  const title = useCachedPaginatedItem<Title>(
    TITLES_QUERY_DOMAIN_KEY,
    id === '*' ? null : id,
  );

  // `titles` comes from the v2 titles search, which excludes royalties Season
  // titles, so a payment rule pointing at one falls through to "Unknown title"
  // rather than resolving. Season names need their own lookup to render here.

  return (
    <strong>
      {id === '*'
        ? 'ALL TITLES'
        : title?.title.toUpperCase() || 'Unknown title'}
    </strong>
  );
};

export default LookupTitleName;
